
// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { 
//   getEmployees, 
//   getEmployeeById, 
//   createEmployee,
//   updateEmployee, 
//   deleteEmployee,
//   permanentDeleteEmployee,
//   updateEmployeePassword,
//   bulkCreateEmployees
// } from '../../Services/Operations/ProductAPI';

// // Skeleton Components
// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Name</th>
//           <th>Email</th>
//           <th>Mobile</th>
//           <th>Role</th>
//           <th>Department</th>
//           <th>Position</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="skeleton-profile-image"></div>
//         {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonEditModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 edit-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const EmployeeManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingEmployee, setEditingEmployee] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingEmployee, setViewingEmployee] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [addForm, setAddForm] = useState({
//     name: '',
//     email: '',
//     password: '',
//     role: 'employee',
//     phoneNumber: '',
//     department: '',
//     position: ''
//   });
//   const [showPasswordModal, setShowPasswordModal] = useState(false);
//   const [passwordForm, setPasswordForm] = useState({
//     currentPassword: '',
//     newPassword: ''
//   });
//   const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [deleteType, setDeleteType] = useState('soft');
//   const [employeeToDelete, setEmployeeToDelete] = useState(null);
//   const [showBulkModal, setShowBulkModal] = useState(false);
//   const [bulkEmployees, setBulkEmployees] = useState('');
//   const [filters, setFilters] = useState({
//     role: '',
//     department: '',
//     status: ''
//   });

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalEmployees, setTotalEmployees] = useState(0);
//   const [pageSize] = useState(10);

//   // Role options
//   const roleOptions = ['employee', 'advanced employee'];
//   const departmentOptions = ['Operations', 'IT', 'HR', 'Finance', 'Sales', 'Marketing', 'Customer Support'];

//   // Calculate starting index for sequential numbering
//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   // Fetch employees on page, search, or filter change
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchEmployees();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters]);

//   const fetchEmployees = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       const response = await getEmployees(
//         token, 
//         currentPage, 
//         pageSize, 
//         searchTerm,
//         filters.role,
//         filters.department,
//         filters.status
//       );

//       if (response && response.data) {
//         const transformedEmployees = response.data.map((employee, index) => ({
//           id: employee._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: employee.profilePicture,
//           name: employee.name || '',
//           email: employee.email || '',
//           mobileNumber: employee.phoneNumber || '',
//           role: employee.role || 'employee',
//           department: employee.department || '',
//           position: employee.position || '',
//           isActive: employee.isActive || false,
//           joined: new Date(employee.createdAt).toISOString().split('T')[0],
//           status: employee.isActive ? 'Active' : 'Inactive',
//         }));

//         setEmployees(transformedEmployees);
//         setTotalPages(response.pages || 1);
//         setTotalEmployees(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch employees.');
//       console.error('Error fetching employees:', err);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleViewEmployee = async (employeeId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getEmployeeById(employeeId, token);
      
//       if (response.success) {
//         const employee = response.data;
//         setViewingEmployee({
//           id: employee._id,
//           name: employee.name || '',
//           email: employee.email || '',
//           mobileNumber: employee.phoneNumber || '',
//           role: employee.role || '',
//           department: employee.department || '',
//           position: employee.position || '',
//           isActive: employee.isActive,
//           profileImage: employee.profilePicture,
//           createdAt: new Date(employee.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           updatedAt: new Date(employee.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           })
//         });
//       } else {
//         setError('Failed to fetch employee details.');
//       }
//     } catch (err) {
//       console.error('Error fetching employee details:', err);
//       setError('Failed to fetch employee details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditEmployee = async (employeeId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getEmployeeById(employeeId, token);
      
//       if (response.success) {
//         const employee = response.data;
//         setEditingEmployee(employee._id);
//         setEditForm({
//           name: employee.name || '',
//           email: employee.email || '',
//           phoneNumber: employee.phoneNumber || '',
//           role: employee.role || 'employee',
//           department: employee.department || '',
//           position: employee.position || '',
//           isActive: employee.isActive || true
//         });
//       } else {
//         setError('Failed to fetch employee details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching employee details for editing:', err);
//       setError('Failed to fetch employee details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phoneNumber: editForm.phoneNumber,
//         role: editForm.role,
//         department: editForm.department,
//         position: editForm.position,
//         isActive: editForm.isActive
//       };

//       const response = await updateEmployee(editingEmployee, updateData, token);
      
//       if (response.success) {
//         setEmployees(prevEmployees =>
//           prevEmployees.map(emp =>
//             emp.id === editingEmployee ? {
//               ...emp,
//               name: response.data.name,
//               email: response.data.email,
//               mobileNumber: response.data.phoneNumber,
//               role: response.data.role,
//               department: response.data.department,
//               position: response.data.position,
//               status: response.data.isActive ? 'Active' : 'Inactive',
//               isActive: response.data.isActive
//             } : emp
//           )
//         );

//         setEditingEmployee(null);
//         setEditForm({});
//         alert('Employee updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update employee.');
//       }
//     } catch (err) {
//       console.error('Error updating employee:', err);
//       setError(err.response?.data?.message || 'Failed to update employee. Please try again.');
//       alert('Failed to update employee. Please try again.');
//     }
//   };

//   const handleAddEmployee = async () => {
//     try {
//       setError(null);
      
//       const response = await createEmployee(addForm, token);
      
//       if (response.success) {
//         setShowAddModal(false);
//         setAddForm({
//           name: '',
//           email: '',
//           password: '',
//           role: 'employee',
//           phoneNumber: '',
//           department: '',
//           position: ''
//         });
//         fetchEmployees();
//         alert('Employee created successfully!');
//       } else {
//         setError(response.message || 'Failed to create employee.');
//       }
//     } catch (err) {
//       console.error('Error creating employee:', err);
//       setError(err.response?.data?.message || 'Failed to create employee. Please try again.');
//     }
//   };

//   const handleUpdatePassword = async () => {
//     try {
//       setError(null);
      
//       const response = await updateEmployeePassword(selectedEmployeeId, passwordForm, token);
      
//       if (response.success) {
//         setShowPasswordModal(false);
//         setPasswordForm({ currentPassword: '', newPassword: '' });
//         setSelectedEmployeeId(null);
        
//         handleRefresh();
        
//         alert('Password updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update password.');
//       }
//     } catch (err) {
//       console.error('Error updating password:', err);
//       setError(err.response?.data?.message || 'Failed to update password. Please try again.');
//     }
//   };

//   const handleDeleteEmployee = async () => {
//     try {
//       setError(null);
      
//       let response;
//       if (deleteType === 'permanent') {
//         response = await permanentDeleteEmployee(employeeToDelete, token);
//       } else {
//         response = await deleteEmployee(employeeToDelete, token);
//       }
      
//       if (response.success) {
//         setShowDeleteConfirm(false);
//         setEmployeeToDelete(null);
//         fetchEmployees();
//         alert(`Employee ${deleteType === 'permanent' ? 'permanently deleted' : 'deactivated'} successfully!`);
//       } else {
//         setError(response.message || 'Failed to delete employee.');
//       }
//     } catch (err) {
//       console.error('Error deleting employee:', err);
//       setError(err.response?.data?.message || 'Failed to delete employee. Please try again.');
//     }
//   };

//   const handleBulkCreate = async () => {
//     try {
//       setError(null);
      
//       let employeesData;
//       try {
//         employeesData = JSON.parse(bulkEmployees);
//       } catch (e) {
//         setError('Invalid JSON format. Please check your input.');
//         return;
//       }
      
//       const response = await bulkCreateEmployees(employeesData, token);
      
//       if (response.success) {
//         setShowBulkModal(false);
//         setBulkEmployees('');
//         fetchEmployees();
//         alert(`${response.count} employees created successfully!`);
//       } else {
//         setError(response.message || 'Failed to create employees.');
//       }
//     } catch (err) {
//       console.error('Error bulk creating employees:', err);
//       setError(err.response?.data?.message || 'Failed to create employees. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingEmployee(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleAddFormChange = (e) => {
//     const { name, value } = e.target;
//     setAddForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handlePasswordFormChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     setCurrentPage(1);
//   };

//   const closeViewModal = () => {
//     setViewingEmployee(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     setSearchTerm('');
//     setFilters({ role: '', department: '', status: '' });
//     fetchEmployees();
//   };

//   const handleExportCSV = () => {
//     const headers = ['Name', 'Email', 'Mobile', 'Role', 'Department', 'Position', 'Status', 'Joined'];
//     const csvData = employees.map(emp => [
//       emp.name,
//       emp.email,
//       emp.mobileNumber,
//       emp.role,
//       emp.department,
//       emp.position,
//       emp.status,
//       emp.joined
//     ]);
    
//     const csvContent = [headers.join(','), ...csvData.map(row => row.join(','))].join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `employees_${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Loading state with skeletons
//   if (loading && employees.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="filters-section">
//           <div className="skeleton-filter"></div>
//           <div className="skeleton-filter"></div>
//           <div className="skeleton-filter"></div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Employee Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search employees by name, email, mobile..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Employee
//           </button>
//           <button className="bulk-btn" onClick={() => setShowBulkModal(true)}>
//             Bulk Create
//           </button>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <select name="role" value={filters.role} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Roles</option>
//           {roleOptions.map(role => (
//             <option key={role} value={role}>{role}</option>
//           ))}
//         </select>
//         <select name="department" value={filters.department} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Departments</option>
//           {departmentOptions.map(dept => (
//             <option key={dept} value={dept}>{dept}</option>
//           ))}
//         </select>
//         <select name="status" value={filters.status} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Status</option>
//           <option value="active">Active</option>
//           <option value="inactive">Inactive</option>
//         </select>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Employees</h3>
//           <p>{totalEmployees}</p>
//           <span>All registered employees</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Employees</h3>
//           <p>{employees.filter(e => e.status === 'Active').length}</p>
//           <span>Active employees</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{employees.length}</p>
//           <span>employees found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Mobile</th>
//               <th>Role</th>
//               <th>Department</th>
//               <th>Position</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.map(employee => (
//               <tr key={employee.id}>
//                 <td>{employee.serialNo}</td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Name"
//                     />
//                   ) : (
//                     <div className="employee-name-cell">
//                       {employee.profileImage && (
//                         <img 
//                           src={`${process.env.REACT_APP_BASE_URL}/uploads/${employee.profileImage}`}
//                           alt={employee.name}
//                           className="employee-avatar-small"
//                           onError={(e) => e.target.style.display = 'none'}
//                         />
//                       )}
//                       <span>{employee.name || 'N/A'}</span>
//                     </div>
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="email"
//                       name="email"
//                       value={editForm.email || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Email"
//                     />
//                   ) : (
//                     employee.email || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="text"
//                       name="phoneNumber"
//                       value={editForm.phoneNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Mobile"
//                     />
//                   ) : (
//                     employee.mobileNumber || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <select
//                       name="role"
//                       value={editForm.role || 'employee'}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       {roleOptions.map(role => (
//                         <option key={role} value={role}>{role}</option>
//                       ))}
//                     </select>
//                   ) : (
//                     <span className={`role-badge role-${employee.role}`}>
//                       {employee.role || 'N/A'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <select
//                       name="department"
//                       value={editForm.department || ''}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       <option value="">Select Department</option>
//                       {departmentOptions.map(dept => (
//                         <option key={dept} value={dept}>{dept}</option>
//                       ))}
//                     </select>
//                   ) : (
//                     employee.department || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="text"
//                       name="position"
//                       value={editForm.position || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Position"
//                     />
//                   ) : (
//                     employee.position || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={editForm.isActive || false}
//                         onChange={handleInputChange}
//                       />
//                       <span className="checkbox-text">
//                         {editForm.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </label>
//                   ) : (
//                     <span className={`status-badge ${employee.status ? employee.status.toLowerCase() : 'inactive'}`}>
//                       {employee.status || 'Inactive'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                         {isFetchingDetails ? 'Saving...' : 'Save'}
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewEmployee(employee.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'View'}
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditEmployee(employee.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'Edit'}
//                       </button>
//                       <button
//                         className="action-btn password"
//                         onClick={() => {
//                           setSelectedEmployeeId(employee.id);
//                           setShowPasswordModal(true);
//                         }}
//                         disabled={isFetchingDetails}
//                       >
//                         Password
//                       </button>
//                       <button
//                         className="action-btn delete"
//                         onClick={() => {
//                           setEmployeeToDelete(employee.id);
//                           setDeleteType('soft');
//                           setShowDeleteConfirm(true);
//                         }}
//                         disabled={isFetchingDetails}
//                       >
//                         Deactivate
//                       </button>
//                       <button
//                         className="action-btn permanent-delete"
//                         onClick={() => {
//                           setEmployeeToDelete(employee.id);
//                           setDeleteType('permanent');
//                           setShowDeleteConfirm(true);
//                         }}
//                         disabled={isFetchingDetails}
//                         title="Permanently Delete"
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {employees.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No employees found matching your search.</p>
//             {searchTerm && (
//               <button className="clear-filters-link" onClick={handleRefresh}>
//                 Clear search to see all employees
//               </button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Pagination */}
//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {employees.length} of {totalEmployees} employees (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Employee Modal */}
//       {viewingEmployee && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Employee Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 {viewingEmployee.profileImage && (
//                   <div className="customer-profile-image">
//                     <img
//                       src={`${process.env.REACT_APP_BASE_URL}/uploads/${viewingEmployee.profileImage}`}
//                       alt={viewingEmployee.name}
//                       className="profile-image-large"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.style.display = 'none';
//                       }}
//                     />
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Name:</label>
//                   <span>{viewingEmployee.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingEmployee.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Mobile Number:</label>
//                   <span>{viewingEmployee.mobileNumber || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Role:</label>
//                   <span>{viewingEmployee.role || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Department:</label>
//                   <span>{viewingEmployee.department || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Position:</label>
//                   <span>{viewingEmployee.position || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Created Date:</label>
//                   <span>{viewingEmployee.createdAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Last Updated:</label>
//                   <span>{viewingEmployee.updatedAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingEmployee.isActive ? 'active' : 'inactive'}`}>
//                     {viewingEmployee.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Loading state for view modal */}
//       {viewingEmployee && isFetchingDetails && <SkeletonModal />}

//       {/* Add Employee Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
//           <div className="modal-content1 add-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Employee</h3>
//               <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:*</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={addForm.name}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Employee Name"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Email:*</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={addForm.email}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Email Address"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Password:*</label>
//                   <input
//                     type="password"
//                     name="password"
//                     value={addForm.password}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Password"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Phone Number:</label>
//                   <input
//                     type="text"
//                     name="phoneNumber"
//                     value={addForm.phoneNumber}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Phone Number"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Role:*</label>
//                   <select
//                     name="role"
//                     value={addForm.role}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     required
//                   >
//                     {roleOptions.map(role => (
//                       <option key={role} value={role}>{role}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Department:</label>
//                   <select
//                     name="department"
//                     value={addForm.department}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                   >
//                     <option value="">Select Department</option>
//                     {departmentOptions.map(dept => (
//                       <option key={dept} value={dept}>{dept}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Position:</label>
//                   <input
//                     type="text"
//                     name="position"
//                     value={addForm.position}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Position"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowAddModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleAddEmployee}>
//                 Create Employee
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Update Password Modal */}
//       {showPasswordModal && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={() => setShowPasswordModal(false)}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Update Password</h3>
//               <button className="modal-close-btn" onClick={() => setShowPasswordModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Current Password:</label>
//                   <input
//                     type="password"
//                     name="currentPassword"
//                     value={passwordForm.currentPassword}
//                     onChange={handlePasswordFormChange}
//                     className="form-control"
//                     placeholder="Current Password"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>New Password:</label>
//                   <input
//                     type="password"
//                     name="newPassword"
//                     value={passwordForm.newPassword}
//                     onChange={handlePasswordFormChange}
//                     className="form-control"
//                     placeholder="New Password"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowPasswordModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleUpdatePassword}>
//                 Update Password
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Form Modal */}
//       {editingEmployee && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Edit Employee</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Employee Name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Email:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={editForm.email || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Email Address"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Phone Number:</label>
//                   <input
//                     type="text"
//                     name="phoneNumber"
//                     value={editForm.phoneNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Phone Number"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Role:</label>
//                   <select
//                     name="role"
//                     value={editForm.role || 'employee'}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     {roleOptions.map(role => (
//                       <option key={role} value={role}>{role}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Department:</label>
//                   <select
//                     name="department"
//                     value={editForm.department || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     <option value="">Select Department</option>
//                     {departmentOptions.map(dept => (
//                       <option key={dept} value={dept}>{dept}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Position:</label>
//                   <input
//                     type="text"
//                     name="position"
//                     value={editForm.position || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Position"
//                   />
//                 </div>
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={editForm.isActive || false}
//                       onChange={handleInputChange}
//                     />
//                     <span className="checkbox-text">Active Employee</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit}>
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Loading state for edit modal */}
//       {editingEmployee && isFetchingDetails && <SkeletonEditModal />}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div className="modal-overlay" onClick={() => setShowDeleteConfirm(false)}>
//           <div className="modal-content1 confirm-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{deleteType === 'permanent' ? 'Permanently Delete Employee' : 'Deactivate Employee'}</h3>
//               <button className="modal-close-btn" onClick={() => setShowDeleteConfirm(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <p>
//                 {deleteType === 'permanent' 
//                   ? 'Are you sure you want to permanently delete this employee? This action cannot be undone.'
//                   : 'Are you sure you want to deactivate this employee? They will no longer be able to access the system.'}
//               </p>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowDeleteConfirm(false)}>
//                 Cancel
//               </button>
//               <button 
//                 className={`action-btn ${deleteType === 'permanent' ? 'permanent-delete' : 'delete'}`} 
//                 onClick={handleDeleteEmployee}
//               >
//                 {deleteType === 'permanent' ? 'Permanently Delete' : 'Deactivate'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Bulk Create Modal */}
//       {showBulkModal && (
//         <div className="modal-overlay" onClick={() => setShowBulkModal(false)}>
//           <div className="modal-content1 bulk-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bulk Create Employees</h3>
//               <button className="modal-close-btn" onClick={() => setShowBulkModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <p>Enter JSON array of employees:</p>
//               <textarea
//                 value={bulkEmployees}
//                 onChange={(e) => setBulkEmployees(e.target.value)}
//                 className="bulk-textarea"
//                 rows={10}
//                 placeholder='[
//   {
//     "name": "John Doe",
//     "email": "john@example.com",
//     "password": "password123",
//     "role": "manager",
//     "phoneNumber": "+1234567890",
//     "department": "Operations",
//     "position": "Operations Manager"
//   }
// ]'
//               />
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowBulkModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleBulkCreate}>
//                 Create Employees
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EmployeeManagement;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { 
//   getEmployees, 
//   getEmployeeById, 
//   createEmployee,
//   updateEmployee, 
//   deleteEmployee,
//   permanentDeleteEmployee,
//   updateEmployeePassword,
//   bulkCreateEmployees
// } from '../../Services/Operations/ProductAPI';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Name</th>
//           <th>Email</th>
//           <th>Mobile</th>
//           <th>Role</th>
//           <th>Department</th>
//           <th>Position</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="skeleton-profile-image"></div>
//         {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonEditModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 edit-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const EmployeeManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingEmployee, setEditingEmployee] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingEmployee, setViewingEmployee] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [addForm, setAddForm] = useState({
//     name: '',
//     email: '',
//     password: '',
//     role: 'employee',
//     phoneNumber: '',
//     department: '',
//     position: ''
//   });
//   const [showPasswordModal, setShowPasswordModal] = useState(false);
//   const [passwordForm, setPasswordForm] = useState({
//     currentPassword: '',
//     newPassword: ''
//   });
//   const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [deleteType, setDeleteType] = useState('soft');
//   const [employeeToDelete, setEmployeeToDelete] = useState(null);
//   const [showBulkModal, setShowBulkModal] = useState(false);
//   const [bulkEmployees, setBulkEmployees] = useState('');
//   const [filters, setFilters] = useState({
//     role: '',
//     department: '',
//     status: ''
//   });
//   const [isAddingEmployee, setIsAddingEmployee] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalEmployees, setTotalEmployees] = useState(0);
//   const [pageSize] = useState(10);

//   // Role options
//   const roleOptions = ['employee', 'advanced employee'];
//   const departmentOptions = ['Operations', 'IT', 'HR', 'Finance', 'Sales', 'Marketing', 'Customer Support'];

//   // Calculate starting index for sequential numbering
//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

// // Refetch when currentPage, searchTerm, or filters change
// useEffect(() => {
//   const delayDebounceFn = setTimeout(() => {
//     if (token) {
//       fetchEmployees();
//     }
//   }, searchTerm ? 500 : 0);

//   return () => clearTimeout(delayDebounceFn);
// }, [currentPage, searchTerm, filters, token]);

// const fetchEmployees = async () => {
//   try {
//     setSearching(true);
//     setLoading(true);
    
//     console.log('Fetching employees with params:', {
//       page: currentPage,
//       search: searchTerm,
//       filters: filters
//     });
    
//     const response = await getEmployees(
//       token, 
//       currentPage, 
//       pageSize, 
//       searchTerm,
//       filters.role,
//       filters.department,
//       filters.status
//     );

//     console.log('API Response:', response);

//     if (response && response.data) {
//       const transformedEmployees = response.data.map((employee, index) => ({
//         id: employee._id,
//         serialNo: getSequentialNumber(index),
//         profileImage: employee.profilePicture,
//         name: employee.name || '',
//         email: employee.email || '',
//         mobileNumber: employee.phoneNumber || '',
//         role: employee.role || 'employee',
//         department: employee.department || '',
//         position: employee.position || '',
//         isActive: employee.isActive || false,
//         joined: new Date(employee.createdAt).toISOString().split('T')[0],
//         status: employee.isActive ? 'Active' : 'Inactive',
//       }));

//       setEmployees(transformedEmployees);
//       setTotalPages(response.pages || 1);
//       setTotalEmployees(response.total || 0);
      
//       console.log('Employees set:', transformedEmployees.length);
//     } else {
//       setEmployees([]);
//       setTotalPages(1);
//       setTotalEmployees(0);
//     }
//   } catch (err) {
//     setError('Failed to fetch employees.');
//     toast.error('Failed to fetch employees. Please refresh the page.');
//     console.error('Error fetching employees:', err);
//     setEmployees([]);
//     setTotalPages(1);
//     setTotalEmployees(0);
//   } finally {
//     setLoading(false);
//     setSearching(false);
//   }
// };

//   const handleViewEmployee = async (employeeId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getEmployeeById(employeeId, token);
      
//       if (response.success) {
//         const employee = response.data;
//         setViewingEmployee({
//           id: employee._id,
//           name: employee.name || '',
//           email: employee.email || '',
//           mobileNumber: employee.phoneNumber || '',
//           role: employee.role || '',
//           department: employee.department || '',
//           position: employee.position || '',
//           isActive: employee.isActive,
//           profileImage: employee.profilePicture,
//           createdAt: new Date(employee.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           updatedAt: new Date(employee.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           })
//         });
//       } else {
//         setError('Failed to fetch employee details.');
//         toast.error('Failed to fetch employee details.');
//       }
//     } catch (err) {
//       console.error('Error fetching employee details:', err);
//       setError('Failed to fetch employee details.');
//       toast.error('Failed to fetch employee details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditEmployee = async (employeeId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getEmployeeById(employeeId, token);
      
//       if (response.success) {
//         const employee = response.data;
//         setEditingEmployee(employee._id);
//         setEditForm({
//           name: employee.name || '',
//           email: employee.email || '',
//           phoneNumber: employee.phoneNumber || '',
//           role: employee.role || 'employee',
//           department: employee.department || '',
//           position: employee.position || '',
//           isActive: employee.isActive || true
//         });
//       } else {
//         setError('Failed to fetch employee details for editing.');
//         toast.error('Failed to fetch employee details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching employee details for editing:', err);
//       setError('Failed to fetch employee details for editing.');
//       toast.error('Failed to fetch employee details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phoneNumber: editForm.phoneNumber,
//         role: editForm.role,
//         department: editForm.department,
//         position: editForm.position,
//         isActive: editForm.isActive
//       };

//       const response = await updateEmployee(editingEmployee, updateData, token);
      
//       if (response.success) {
//         setEmployees(prevEmployees =>
//           prevEmployees.map(emp =>
//             emp.id === editingEmployee ? {
//               ...emp,
//               name: response.data.name,
//               email: response.data.email,
//               mobileNumber: response.data.phoneNumber,
//               role: response.data.role,
//               department: response.data.department,
//               position: response.data.position,
//               status: response.data.isActive ? 'Active' : 'Inactive',
//               isActive: response.data.isActive
//             } : emp
//           )
//         );

//         setEditingEmployee(null);
//         setEditForm({});
//         toast.success('Employee updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update employee.');
//         toast.error(response.message || 'Failed to update employee.');
//       }
//     } catch (err) {
//       console.error('Error updating employee:', err);
//       const errorMessage = err.response?.data?.message || 'Failed to update employee. Please try again.';
//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

// const handleAddEmployee = async () => {
//   // Validate required fields
//   if (!addForm.name.trim()) {
//     toast.error('Please enter employee name');
//     return;
//   }
//   if (!addForm.email.trim()) {
//     toast.error('Please enter employee email');
//     return;
//   }
//   if (!addForm.password.trim()) {
//     toast.error('Please enter employee password');
//     return;
//   }
  
//   // Email validation
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   if (!emailRegex.test(addForm.email)) {
//     toast.error('Please enter a valid email address');
//     return;
//   }
  
//   // Password validation (minimum 6 characters)
//   if (addForm.password.length < 6) {
//     toast.error('Password must be at least 6 characters long');
//     return;
//   }

//   try {
//     setIsAddingEmployee(true);
//     setError(null);
    
//     const response = await createEmployee(addForm, token);
    
//     if (response.success) {
//       // Close modal
//       setShowAddModal(false);
      
//       // Reset form
//       setAddForm({
//         name: '',
//         email: '',
//         password: '',
//         role: 'employee',
//         phoneNumber: '',
//         department: '',
//         position: ''
//       });
      
//       // Reset all filters and search to show all employees
//       setCurrentPage(1);
//       setSearchTerm('');
//       setFilters({ role: '', department: '', status: '' });
      
//       // Show success message
//       toast.success(`Employee "${addForm.name}" created successfully!`);
      
//       // Don't call fetchEmployees or handleRefresh here
//       // The useEffect will automatically trigger fetch when state changes
      
//     } else {
//       // Handle specific error cases
//       let errorMsg = response.message || 'Failed to create employee.';
      
//       if (errorMsg.toLowerCase().includes('email already exists')) {
//         errorMsg = `Employee with email "${addForm.email}" already exists. Please use a different email.`;
//       } else if (errorMsg.toLowerCase().includes('duplicate')) {
//         errorMsg = 'An employee with this information already exists.';
//       }
      
//       setError(errorMsg);
//       toast.error(errorMsg);
//     }
//   } catch (err) {
//     console.error('Error creating employee:', err);
//     let errorMessage = 'Failed to create employee. Please try again.';
    
//     // Handle different error scenarios
//     if (err.response?.data?.message) {
//       const serverMsg = err.response.data.message;
//       if (serverMsg.toLowerCase().includes('email already exists')) {
//         errorMessage = `Employee with email "${addForm.email}" already exists. Please use a different email.`;
//       } else {
//         errorMessage = serverMsg;
//       }
//     } else if (err.message) {
//       errorMessage = err.message;
//     }
    
//     setError(errorMessage);
//     toast.error(errorMessage);
//   } finally {
//     setIsAddingEmployee(false);
//   }
// };

//   const handleUpdatePassword = async () => {
//     try {
//       setError(null);
      
//       const response = await updateEmployeePassword(selectedEmployeeId, passwordForm, token);
      
//       if (response.success) {
//         setShowPasswordModal(false);
//         setPasswordForm({ currentPassword: '', newPassword: '' });
//         setSelectedEmployeeId(null);
        
//         handleRefresh();
        
//         toast.success('Password updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update password.');
//         toast.error(response.message || 'Failed to update password.');
//       }
//     } catch (err) {
//       console.error('Error updating password:', err);
//       const errorMessage = err.response?.data?.message || 'Failed to update password. Please try again.';
//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const handleDeleteEmployee = async () => {
//     try {
//       setError(null);
      
//       let response;
//       if (deleteType === 'permanent') {
//         response = await permanentDeleteEmployee(employeeToDelete, token);
//       } else {
//         response = await deleteEmployee(employeeToDelete, token);
//       }
      
//       if (response.success) {
//         setShowDeleteConfirm(false);
//         setEmployeeToDelete(null);
//         fetchEmployees();
//         const message = deleteType === 'permanent' 
//           ? 'Employee permanently deleted successfully!' 
//           : 'Employee deactivated successfully!';
//         toast.success(message);
//       } else {
//         setError(response.message || 'Failed to delete employee.');
//         toast.error(response.message || 'Failed to delete employee.');
//       }
//     } catch (err) {
//       console.error('Error deleting employee:', err);
//       const errorMessage = err.response?.data?.message || 'Failed to delete employee. Please try again.';
//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const handleBulkCreate = async () => {
//     try {
//       setError(null);
      
//       let employeesData;
//       try {
//         employeesData = JSON.parse(bulkEmployees);
//         if (!Array.isArray(employeesData)) {
//           throw new Error('Data must be an array');
//         }
//       } catch (e) {
//         setError('Invalid JSON format. Please check your input.');
//         toast.error('Invalid JSON format. Please check your input.');
//         return;
//       }
      
//       const response = await bulkCreateEmployees(employeesData, token);
      
//       if (response.success) {
//         setShowBulkModal(false);
//         setBulkEmployees('');
//         fetchEmployees();
//         toast.success(`${response.count || employeesData.length} employees created successfully!`);
//       } else {
//         setError(response.message || 'Failed to create employees.');
//         toast.error(response.message || 'Failed to create employees.');
//       }
//     } catch (err) {
//       console.error('Error bulk creating employees:', err);
//       const errorMessage = err.response?.data?.message || 'Failed to create employees. Please try again.';
//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingEmployee(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleAddFormChange = (e) => {
//     const { name, value } = e.target;
//     setAddForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handlePasswordFormChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     setCurrentPage(1);
//   };

//   const closeViewModal = () => {
//     setViewingEmployee(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//   setCurrentPage(1);
//   setSearchTerm('');
//   setFilters({ role: '', department: '', status: '' });
//      fetchEmployees();
//   };

//   const handleExportCSV = () => {
//     const headers = ['Name', 'Email', 'Mobile', 'Role', 'Department', 'Position', 'Status', 'Joined'];
//     const csvData = employees.map(emp => [
//       emp.name,
//       emp.email,
//       emp.mobileNumber,
//       emp.role,
//       emp.department,
//       emp.position,
//       emp.status,
//       emp.joined
//     ]);
    
//     const csvContent = [headers.join(','), ...csvData.map(row => row.join(','))].join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `employees_${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//     window.URL.revokeObjectURL(url);
    
//     toast.success('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

// const handleCloseAddModal = () => {
//   setShowAddModal(false);
//   setAddForm({
//     name: '',
//     email: '',
//     password: '',
//     role: 'employee',
//     phoneNumber: '',
//     department: '',
//     position: ''
//   });
//   setError(null);
// };

//   // Loading state with skeletons
//   if (loading && employees.length === 0) {
//     return (
//       <div className="management-page">
//         <ToastContainer 
//           position="top-right"
//           autoClose={5000}
//           hideProgressBar={false}
//           newestOnTop
//           closeOnClick
//           rtl={false}
//           pauseOnFocusLoss
//           draggable
//           pauseOnHover
//           theme="light"
//         />
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="filters-section">
//           <div className="skeleton-filter"></div>
//           <div className="skeleton-filter"></div>
//           <div className="skeleton-filter"></div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <ToastContainer 
//         position="top-right"
//         autoClose={5000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="light"
//       />
      
//       <div className="page-header">
//         <h1>Employee Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search employees by name, email, mobile..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Employee
//           </button>
//           <button className="bulk-btn" onClick={() => setShowBulkModal(true)}>
//             Bulk Create
//           </button>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <select name="role" value={filters.role} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Roles</option>
//           {roleOptions.map(role => (
//             <option key={role} value={role}>{role}</option>
//           ))}
//         </select>
//         <select name="department" value={filters.department} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Departments</option>
//           {departmentOptions.map(dept => (
//             <option key={dept} value={dept}>{dept}</option>
//           ))}
//         </select>
//         <select name="status" value={filters.status} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Status</option>
//           <option value="active">Active</option>
//           <option value="inactive">Inactive</option>
//         </select>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Employees</h3>
//           <p>{totalEmployees}</p>
//           <span>All registered employees</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Employees</h3>
//           <p>{employees.filter(e => e.status === 'Active').length}</p>
//           <span>Active employees</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{employees.length}</p>
//           <span>employees found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Mobile</th>
//               <th>Role</th>
//               <th>Department</th>
//               <th>Position</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.map(employee => (
//               <tr key={employee.id}>
//                 <td>{employee.serialNo}</td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Name"
//                     />
//                   ) : (
//                     <div className="employee-name-cell">
//                       {employee.profileImage && (
//                         <img 
//                           src={`${process.env.REACT_APP_BASE_URL}/uploads/${employee.profileImage}`}
//                           alt={employee.name}
//                           className="employee-avatar-small"
//                           onError={(e) => e.target.style.display = 'none'}
//                         />
//                       )}
//                       <span>{employee.name || 'N/A'}</span>
//                     </div>
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="email"
//                       name="email"
//                       value={editForm.email || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Email"
//                     />
//                   ) : (
//                     employee.email || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="text"
//                       name="phoneNumber"
//                       value={editForm.phoneNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Mobile"
//                     />
//                   ) : (
//                     employee.mobileNumber || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <select
//                       name="role"
//                       value={editForm.role || 'employee'}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       {roleOptions.map(role => (
//                         <option key={role} value={role}>{role}</option>
//                       ))}
//                     </select>
//                   ) : (
//                     <span className={`role-badge role-${employee.role}`}>
//                       {employee.role || 'N/A'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <select
//                       name="department"
//                       value={editForm.department || ''}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       <option value="">Select Department</option>
//                       {departmentOptions.map(dept => (
//                         <option key={dept} value={dept}>{dept}</option>
//                       ))}
//                     </select>
//                   ) : (
//                     employee.department || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <input
//                       type="text"
//                       name="position"
//                       value={editForm.position || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Position"
//                     />
//                   ) : (
//                     employee.position || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={editForm.isActive || false}
//                         onChange={handleInputChange}
//                       />
//                       <span className="checkbox-text">
//                         {editForm.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </label>
//                   ) : (
//                     <span className={`status-badge ${employee.status ? employee.status.toLowerCase() : 'inactive'}`}>
//                       {employee.status || 'Inactive'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingEmployee === employee.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                         {isFetchingDetails ? 'Saving...' : 'Save'}
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewEmployee(employee.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'View'}
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditEmployee(employee.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'Edit'}
//                       </button>
//                       <button
//                         className="action-btn password"
//                         onClick={() => {
//                           setSelectedEmployeeId(employee.id);
//                           setShowPasswordModal(true);
//                         }}
//                         disabled={isFetchingDetails}
//                       >
//                         Password
//                       </button>
//                       <button
//                         className="action-btn delete"
//                         onClick={() => {
//                           setEmployeeToDelete(employee.id);
//                           setDeleteType('soft');
//                           setShowDeleteConfirm(true);
//                         }}
//                         disabled={isFetchingDetails}
//                       >
//                         Deactivate
//                       </button>
//                       <button
//                         className="action-btn permanent-delete"
//                         onClick={() => {
//                           setEmployeeToDelete(employee.id);
//                           setDeleteType('permanent');
//                           setShowDeleteConfirm(true);
//                         }}
//                         disabled={isFetchingDetails}
//                         title="Permanently Delete"
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {employees.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No employees found matching your search.</p>
//             {searchTerm && (
//               <button className="clear-filters-link" onClick={handleRefresh}>
//                 Clear search to see all employees
//               </button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Pagination */}
//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {employees.length} of {totalEmployees} employees (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Employee Modal */}
//       {viewingEmployee && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Employee Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 {viewingEmployee.profileImage && (
//                   <div className="customer-profile-image">
//                     <img
//                       src={`${process.env.REACT_APP_BASE_URL}/uploads/${viewingEmployee.profileImage}`}
//                       alt={viewingEmployee.name}
//                       className="profile-image-large"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.style.display = 'none';
//                       }}
//                     />
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Name:</label>
//                   <span>{viewingEmployee.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingEmployee.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Mobile Number:</label>
//                   <span>{viewingEmployee.mobileNumber || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Role:</label>
//                   <span>{viewingEmployee.role || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Department:</label>
//                   <span>{viewingEmployee.department || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Position:</label>
//                   <span>{viewingEmployee.position || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Created Date:</label>
//                   <span>{viewingEmployee.createdAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Last Updated:</label>
//                   <span>{viewingEmployee.updatedAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingEmployee.isActive ? 'active' : 'inactive'}`}>
//                     {viewingEmployee.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Loading state for view modal */}
//       {viewingEmployee && isFetchingDetails && <SkeletonModal />}

//       {/* Add Employee Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={handleCloseAddModal}>
//           <div className="modal-content1 add-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Employee</h3>
//               <button className="modal-close-btn" onClick={handleCloseAddModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:*</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={addForm.name}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Employee Name"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Email:*</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={addForm.email}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Email Address"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Password:*</label>
//                   <input
//                     type="password"
//                     name="password"
//                     value={addForm.password}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Password (min. 6 characters)"
//                     required
//                   />
//                   <small className="form-text text-muted">Password must be at least 6 characters long</small>
//                 </div>
//                 <div className="form-group">
//                   <label>Phone Number:</label>
//                   <input
//                     type="text"
//                     name="phoneNumber"
//                     value={addForm.phoneNumber}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Phone Number"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Role:*</label>
//                   <select
//                     name="role"
//                     value={addForm.role}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     required
//                   >
//                     {roleOptions.map(role => (
//                       <option key={role} value={role}>{role}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Department:</label>
//                   <select
//                     name="department"
//                     value={addForm.department}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                   >
//                     <option value="">Select Department</option>
//                     {departmentOptions.map(dept => (
//                       <option key={dept} value={dept}>{dept}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Position:</label>
//                   <input
//                     type="text"
//                     name="position"
//                     value={addForm.position}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Position"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCloseAddModal} disabled={isAddingEmployee}>
//                 Cancel
//               </button>
//               <button 
//                 className="action-btn save" 
//                 onClick={handleAddEmployee}
//                 disabled={isAddingEmployee}
//               >
//                 {isAddingEmployee ? 'Creating...' : 'Create Employee'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Update Password Modal */}
//       {showPasswordModal && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={() => setShowPasswordModal(false)}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Update Password</h3>
//               <button className="modal-close-btn" onClick={() => setShowPasswordModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Current Password:</label>
//                   <input
//                     type="password"
//                     name="currentPassword"
//                     value={passwordForm.currentPassword}
//                     onChange={handlePasswordFormChange}
//                     className="form-control"
//                     placeholder="Current Password"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>New Password:</label>
//                   <input
//                     type="password"
//                     name="newPassword"
//                     value={passwordForm.newPassword}
//                     onChange={handlePasswordFormChange}
//                     className="form-control"
//                     placeholder="New Password"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowPasswordModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleUpdatePassword}>
//                 Update Password
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Form Modal */}
//       {editingEmployee && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Edit Employee</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Employee Name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Email:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={editForm.email || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Email Address"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Phone Number:</label>
//                   <input
//                     type="text"
//                     name="phoneNumber"
//                     value={editForm.phoneNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Phone Number"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Role:</label>
//                   <select
//                     name="role"
//                     value={editForm.role || 'employee'}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     {roleOptions.map(role => (
//                       <option key={role} value={role}>{role}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Department:</label>
//                   <select
//                     name="department"
//                     value={editForm.department || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     <option value="">Select Department</option>
//                     {departmentOptions.map(dept => (
//                       <option key={dept} value={dept}>{dept}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Position:</label>
//                   <input
//                     type="text"
//                     name="position"
//                     value={editForm.position || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Position"
//                   />
//                 </div>
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={editForm.isActive || false}
//                       onChange={handleInputChange}
//                     />
//                     <span className="checkbox-text">Active Employee</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit}>
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Loading state for edit modal */}
//       {editingEmployee && isFetchingDetails && <SkeletonEditModal />}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div className="modal-overlay" onClick={() => setShowDeleteConfirm(false)}>
//           <div className="modal-content1 confirm-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{deleteType === 'permanent' ? 'Permanently Delete Employee' : 'Deactivate Employee'}</h3>
//               <button className="modal-close-btn" onClick={() => setShowDeleteConfirm(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <p>
//                 {deleteType === 'permanent' 
//                   ? 'Are you sure you want to permanently delete this employee? This action cannot be undone.'
//                   : 'Are you sure you want to deactivate this employee? They will no longer be able to access the system.'}
//               </p>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowDeleteConfirm(false)}>
//                 Cancel
//               </button>
//               <button 
//                 className={`action-btn ${deleteType === 'permanent' ? 'permanent-delete' : 'delete'}`} 
//                 onClick={handleDeleteEmployee}
//               >
//                 {deleteType === 'permanent' ? 'Permanently Delete' : 'Deactivate'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Bulk Create Modal */}
//       {showBulkModal && (
//         <div className="modal-overlay" onClick={() => setShowBulkModal(false)}>
//           <div className="modal-content1 bulk-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bulk Create Employees</h3>
//               <button className="modal-close-btn" onClick={() => setShowBulkModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <p>Enter JSON array of employees:</p>
//               <textarea
//                 value={bulkEmployees}
//                 onChange={(e) => setBulkEmployees(e.target.value)}
//                 className="bulk-textarea"
//                 rows={10}
//                 placeholder='[
//   {
//     "name": "John Doe",
//     "email": "john@example.com",
//     "password": "password123",
//     "role": "manager",
//     "phoneNumber": "+1234567890",
//     "department": "Operations",
//     "position": "Operations Manager"
//   }
// ]'
//               />
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowBulkModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleBulkCreate}>
//                 Create Employees
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EmployeeManagement;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../Styles/ManagementPages.css';
import '../../Styles/CustomerManage.css';
import { 
  getEmployees, 
  getEmployeeById, 
  createEmployee,
  updateEmployee, 
  deleteEmployee,
  permanentDeleteEmployee,
  updateEmployeePassword,
  bulkCreateEmployees
} from '../../Services/Operations/ProductAPI';

const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Name</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Role</th>
          <th>Department</th>
          <th>Position</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        <div className="skeleton-profile-image"></div>
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} className="skeleton-detail-row">
            <div className="skeleton-label"></div>
            <div className="skeleton-value"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const SkeletonEditModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 edit-modal skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} className="form-group">
            <div className="skeleton-label"></div>
            <div className="skeleton-input"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const EmployeeManagement = () => {
  const { token } = useSelector(state => state.user);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingEmployee, setViewingEmployee] = useState(null);
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addForm, setAddForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'employee',
    phoneNumber: '',
    department: '',
    position: ''
  });
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    newPassword: '' // ✅ Only newPassword, removed currentPassword
  });
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteType, setDeleteType] = useState('soft');
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkEmployees, setBulkEmployees] = useState('');
  const [filters, setFilters] = useState({
    role: '',
    department: '',
    status: ''
  });
  const [isAddingEmployee, setIsAddingEmployee] = useState(false);
  const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [pageSize] = useState(10);

  // Role options
  const roleOptions = ['employee', 'advanced employee'];
  const departmentOptions = ['Operations', 'IT', 'HR', 'Finance', 'Sales', 'Marketing', 'Customer Support'];

  // Calculate starting index for sequential numbering
  const getSequentialNumber = (index) => {
    return (currentPage - 1) * pageSize + index + 1;
  };

// Refetch when currentPage, searchTerm, or filters change
useEffect(() => {
  const delayDebounceFn = setTimeout(() => {
    if (token) {
      fetchEmployees();
    }
  }, searchTerm ? 500 : 0);

  return () => clearTimeout(delayDebounceFn);
}, [currentPage, searchTerm, filters, token]);

const fetchEmployees = async () => {
  try {
    setSearching(true);
    setLoading(true);
    
    console.log('Fetching employees with params:', {
      page: currentPage,
      search: searchTerm,
      filters: filters
    });
    
    const response = await getEmployees(
      token, 
      currentPage, 
      pageSize, 
      searchTerm,
      filters.role,
      filters.department,
      filters.status
    );

    console.log('API Response:', response);

    if (response && response.data) {
      const transformedEmployees = response.data.map((employee, index) => ({
        id: employee._id,
        serialNo: getSequentialNumber(index),
        profileImage: employee.profilePicture,
        name: employee.name || '',
        email: employee.email || '',
        mobileNumber: employee.phoneNumber || '',
        role: employee.role || 'employee',
        department: employee.department || '',
        position: employee.position || '',
        isActive: employee.isActive || false,
        joined: new Date(employee.createdAt).toISOString().split('T')[0],
        status: employee.isActive ? 'Active' : 'Inactive',
      }));

      setEmployees(transformedEmployees);
      setTotalPages(response.pages || 1);
      setTotalEmployees(response.total || 0);
      
      console.log('Employees set:', transformedEmployees.length);
    } else {
      setEmployees([]);
      setTotalPages(1);
      setTotalEmployees(0);
    }
  } catch (err) {
    setError('Failed to fetch employees.');
    toast.error('Failed to fetch employees. Please refresh the page.');
    console.error('Error fetching employees:', err);
    setEmployees([]);
    setTotalPages(1);
    setTotalEmployees(0);
  } finally {
    setLoading(false);
    setSearching(false);
  }
};

  const handleViewEmployee = async (employeeId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getEmployeeById(employeeId, token);
      
      if (response.success) {
        const employee = response.data;
        setViewingEmployee({
          id: employee._id,
          name: employee.name || '',
          email: employee.email || '',
          mobileNumber: employee.phoneNumber || '',
          role: employee.role || '',
          department: employee.department || '',
          position: employee.position || '',
          isActive: employee.isActive,
          profileImage: employee.profilePicture,
          createdAt: new Date(employee.createdAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }),
          updatedAt: new Date(employee.updatedAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        });
      } else {
        setError('Failed to fetch employee details.');
        toast.error('Failed to fetch employee details.');
      }
    } catch (err) {
      console.error('Error fetching employee details:', err);
      setError('Failed to fetch employee details.');
      toast.error('Failed to fetch employee details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleEditEmployee = async (employeeId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getEmployeeById(employeeId, token);
      
      if (response.success) {
        const employee = response.data;
        setEditingEmployee(employee._id);
        setEditForm({
          name: employee.name || '',
          email: employee.email || '',
          phoneNumber: employee.phoneNumber || '',
          role: employee.role || 'employee',
          department: employee.department || '',
          position: employee.position || '',
          isActive: employee.isActive || true
        });
      } else {
        setError('Failed to fetch employee details for editing.');
        toast.error('Failed to fetch employee details for editing.');
      }
    } catch (err) {
      console.error('Error fetching employee details for editing:', err);
      setError('Failed to fetch employee details for editing.');
      toast.error('Failed to fetch employee details for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);
      
      const updateData = {
        name: editForm.name,
        email: editForm.email,
        phoneNumber: editForm.phoneNumber,
        role: editForm.role,
        department: editForm.department,
        position: editForm.position,
        isActive: editForm.isActive
      };

      const response = await updateEmployee(editingEmployee, updateData, token);
      
      if (response.success) {
        setEmployees(prevEmployees =>
          prevEmployees.map(emp =>
            emp.id === editingEmployee ? {
              ...emp,
              name: response.data.name,
              email: response.data.email,
              mobileNumber: response.data.phoneNumber,
              role: response.data.role,
              department: response.data.department,
              position: response.data.position,
              status: response.data.isActive ? 'Active' : 'Inactive',
              isActive: response.data.isActive
            } : emp
          )
        );

        setEditingEmployee(null);
        setEditForm({});
        toast.success('Employee updated successfully!');
      } else {
        setError(response.message || 'Failed to update employee.');
        toast.error(response.message || 'Failed to update employee.');
      }
    } catch (err) {
      console.error('Error updating employee:', err);
      const errorMessage = err.response?.data?.message || 'Failed to update employee. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

const handleAddEmployee = async () => {
  // Validate required fields
  if (!addForm.name.trim()) {
    toast.error('Please enter employee name');
    return;
  }
  if (!addForm.email.trim()) {
    toast.error('Please enter employee email');
    return;
  }
  if (!addForm.password.trim()) {
    toast.error('Please enter employee password');
    return;
  }
  
  // Email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(addForm.email)) {
    toast.error('Please enter a valid email address');
    return;
  }
  
  // Password validation (minimum 6 characters)
  if (addForm.password.length < 6) {
    toast.error('Password must be at least 6 characters long');
    return;
  }

  try {
    setIsAddingEmployee(true);
    setError(null);
    
    const response = await createEmployee(addForm, token);
    
    if (response.success) {
      // Close modal
      setShowAddModal(false);
      
      // Reset form
      setAddForm({
        name: '',
        email: '',
        password: '',
        role: 'employee',
        phoneNumber: '',
        department: '',
        position: ''
      });
      
      // Reset all filters and search to show all employees
      setCurrentPage(1);
      setSearchTerm('');
      setFilters({ role: '', department: '', status: '' });
      
      // Show success message
      toast.success(`Employee "${addForm.name}" created successfully!`);
      
      // Don't call fetchEmployees or handleRefresh here
      // The useEffect will automatically trigger fetch when state changes
      
    } else {
      // Handle specific error cases
      let errorMsg = response.message || 'Failed to create employee.';
      
      if (errorMsg.toLowerCase().includes('email already exists')) {
        errorMsg = `Employee with email "${addForm.email}" already exists. Please use a different email.`;
      } else if (errorMsg.toLowerCase().includes('duplicate')) {
        errorMsg = 'An employee with this information already exists.';
      }
      
      setError(errorMsg);
      toast.error(errorMsg);
    }
  } catch (err) {
    console.error('Error creating employee:', err);
    let errorMessage = 'Failed to create employee. Please try again.';
    
    // Handle different error scenarios
    if (err.response?.data?.message) {
      const serverMsg = err.response.data.message;
      if (serverMsg.toLowerCase().includes('email already exists')) {
        errorMessage = `Employee with email "${addForm.email}" already exists. Please use a different email.`;
      } else {
        errorMessage = serverMsg;
      }
    } else if (err.message) {
      errorMessage = err.message;
    }
    
    setError(errorMessage);
    toast.error(errorMessage);
  } finally {
    setIsAddingEmployee(false);
  }
};

  const handleUpdatePassword = async () => {
    // Validate new password
    if (!passwordForm.newPassword || passwordForm.newPassword.length < 6) {
      toast.error('New password must be at least 6 characters long');
      return;
    }

    try {
      setIsUpdatingPassword(true);
      setError(null);
      
      // ✅ Only send newPassword (no currentPassword)
      const response = await updateEmployeePassword(selectedEmployeeId, passwordForm, token);
      
      if (response.success) {
        setShowPasswordModal(false);
        setPasswordForm({ newPassword: '' }); // ✅ Reset only newPassword
        setSelectedEmployeeId(null);
        
        handleRefresh();
        
        toast.success('Password updated successfully!');
      } else {
        setError(response.message || 'Failed to update password.');
        toast.error(response.message || 'Failed to update password.');
      }
    } catch (err) {
      console.error('Error updating password:', err);
      const errorMessage = err.response?.data?.message || 'Failed to update password. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsUpdatingPassword(false);
    }
  };

  const handleDeleteEmployee = async () => {
    try {
      setError(null);
      
      let response;
      if (deleteType === 'permanent') {
        response = await permanentDeleteEmployee(employeeToDelete, token);
      } else {
        response = await deleteEmployee(employeeToDelete, token);
      }
      
      if (response.success) {
        setShowDeleteConfirm(false);
        setEmployeeToDelete(null);
        fetchEmployees();
        const message = deleteType === 'permanent' 
          ? 'Employee permanently deleted successfully!' 
          : 'Employee deactivated successfully!';
        toast.success(message);
      } else {
        setError(response.message || 'Failed to delete employee.');
        toast.error(response.message || 'Failed to delete employee.');
      }
    } catch (err) {
      console.error('Error deleting employee:', err);
      const errorMessage = err.response?.data?.message || 'Failed to delete employee. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  const handleBulkCreate = async () => {
    try {
      setError(null);
      
      let employeesData;
      try {
        employeesData = JSON.parse(bulkEmployees);
        if (!Array.isArray(employeesData)) {
          throw new Error('Data must be an array');
        }
      } catch (e) {
        setError('Invalid JSON format. Please check your input.');
        toast.error('Invalid JSON format. Please check your input.');
        return;
      }
      
      const response = await bulkCreateEmployees(employeesData, token);
      
      if (response.success) {
        setShowBulkModal(false);
        setBulkEmployees('');
        fetchEmployees();
        toast.success(`${response.count || employeesData.length} employees created successfully!`);
      } else {
        setError(response.message || 'Failed to create employees.');
        toast.error(response.message || 'Failed to create employees.');
      }
    } catch (err) {
      console.error('Error bulk creating employees:', err);
      const errorMessage = err.response?.data?.message || 'Failed to create employees. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  const handleCancelEdit = () => {
    setEditingEmployee(null);
    setEditForm({});
    setError(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleAddFormChange = (e) => {
    const { name, value } = e.target;
    setAddForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePasswordFormChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
    setCurrentPage(1);
  };

  const closeViewModal = () => {
    setViewingEmployee(null);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleRefresh = () => {
  setCurrentPage(1);
  setSearchTerm('');
  setFilters({ role: '', department: '', status: '' });
     fetchEmployees();
  };

  const handleExportCSV = () => {
    const headers = ['Name', 'Email', 'Mobile', 'Role', 'Department', 'Position', 'Status', 'Joined'];
    const csvData = employees.map(emp => [
      emp.name,
      emp.email,
      emp.mobileNumber,
      emp.role,
      emp.department,
      emp.position,
      emp.status,
      emp.joined
    ]);
    
    const csvContent = [headers.join(','), ...csvData.map(row => row.join(','))].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `employees_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    
    toast.success('CSV exported successfully!');
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

const handleCloseAddModal = () => {
  setShowAddModal(false);
  setAddForm({
    name: '',
    email: '',
    password: '',
    role: 'employee',
    phoneNumber: '',
    department: '',
    position: ''
  });
  setError(null);
};

const handleClosePasswordModal = () => {
  setShowPasswordModal(false);
  setPasswordForm({ newPassword: '' });
  setSelectedEmployeeId(null);
  setError(null);
};

  // Loading state with skeletons
  if (loading && employees.length === 0) {
    return (
      <div className="management-page">
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="filters-section">
          <div className="skeleton-filter"></div>
          <div className="skeleton-filter"></div>
          <div className="skeleton-filter"></div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      
      <div className="page-header">
        <h1>Employee Management</h1>
        <div className="header-actions">
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Search employees by name, email, mobile..."
              className="search-input"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searching && (
              <span style={{
                position: 'absolute', right: '10px', top: '50%',
                transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
              }}>
                searching...
              </span>
            )}
          </div>
          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          <button className="export-btn" onClick={handleExportCSV}>
            Export CSV
          </button>
          <button className="add-btn" onClick={() => setShowAddModal(true)}>
            + Add Employee
          </button>
          <button className="bulk-btn" onClick={() => setShowBulkModal(true)}>
            Bulk Create
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="filters-section">
        <select name="role" value={filters.role} onChange={handleFilterChange} className="filter-select">
          <option value="">All Roles</option>
          {roleOptions.map(role => (
            <option key={role} value={role}>{role}</option>
          ))}
        </select>
        <select name="department" value={filters.department} onChange={handleFilterChange} className="filter-select">
          <option value="">All Departments</option>
          {departmentOptions.map(dept => (
            <option key={dept} value={dept}>{dept}</option>
          ))}
        </select>
        <select name="status" value={filters.status} onChange={handleFilterChange} className="filter-select">
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Employees</h3>
          <p>{totalEmployees}</p>
          <span>All registered employees</span>
        </div>
        <div className="stat-card">
          <h3>Active Employees</h3>
          <p>{employees.filter(e => e.status === 'Active').length}</p>
          <span>Active employees</span>
        </div>
        <div className="stat-card">
          <h3>Search Results</h3>
          <p>{employees.length}</p>
          <span>employees found</span>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Role</th>
              <th>Department</th>
              <th>Position</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {employees.map(employee => (
              <tr key={employee.id}>
                <td>{employee.serialNo}</td>
                <td>
                  {editingEmployee === employee.id ? (
                    <input
                      type="text"
                      name="name"
                      value={editForm.name || ''}
                      onChange={handleInputChange}
                      className="edit-input"
                      placeholder="Name"
                    />
                  ) : (
                    <div className="employee-name-cell">
                      {employee.profileImage && (
                        <img 
                          src={`${process.env.REACT_APP_BASE_URL}/uploads/${employee.profileImage}`}
                          alt={employee.name}
                          className="employee-avatar-small"
                          onError={(e) => e.target.style.display = 'none'}
                        />
                      )}
                      <span>{employee.name || 'N/A'}</span>
                    </div>
                  )}
                </td>
                <td>
                  {editingEmployee === employee.id ? (
                    <input
                      type="email"
                      name="email"
                      value={editForm.email || ''}
                      onChange={handleInputChange}
                      className="edit-input"
                      placeholder="Email"
                    />
                  ) : (
                    employee.email || 'N/A'
                  )}
                </td>
                <td>
                  {editingEmployee === employee.id ? (
                    <input
                      type="text"
                      name="phoneNumber"
                      value={editForm.phoneNumber || ''}
                      onChange={handleInputChange}
                      className="edit-input"
                      placeholder="Mobile"
                    />
                  ) : (
                    employee.mobileNumber || 'N/A'
                  )}
                </td>
                <td>
                  {editingEmployee === employee.id ? (
                    <select
                      name="role"
                      value={editForm.role || 'employee'}
                      onChange={handleInputChange}
                      className="edit-select"
                    >
                      {roleOptions.map(role => (
                        <option key={role} value={role}>{role}</option>
                      ))}
                    </select>
                  ) : (
                    <span className={`role-badge role-${employee.role}`}>
                      {employee.role || 'N/A'}
                    </span>
                  )}
                </td>
                <td>
                  {editingEmployee === employee.id ? (
                    <select
                      name="department"
                      value={editForm.department || ''}
                      onChange={handleInputChange}
                      className="edit-select"
                    >
                      <option value="">Select Department</option>
                      {departmentOptions.map(dept => (
                        <option key={dept} value={dept}>{dept}</option>
                      ))}
                    </select>
                  ) : (
                    employee.department || 'N/A'
                  )}
                </td>
                <td>
                  {editingEmployee === employee.id ? (
                    <input
                      type="text"
                      name="position"
                      value={editForm.position || ''}
                      onChange={handleInputChange}
                      className="edit-input"
                      placeholder="Position"
                    />
                  ) : (
                    employee.position || 'N/A'
                  )}
                </td>
                <td>
                  {editingEmployee === employee.id ? (
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="isActive"
                        checked={editForm.isActive || false}
                        onChange={handleInputChange}
                      />
                      <span className="checkbox-text">
                        {editForm.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </label>
                  ) : (
                    <span className={`status-badge ${employee.status ? employee.status.toLowerCase() : 'inactive'}`}>
                      {employee.status || 'Inactive'}
                    </span>
                  )}
                </td>
                <td>
                  {editingEmployee === employee.id ? (
                    <div className="edit-actions">
                      <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
                        {isFetchingDetails ? 'Saving...' : 'Save'}
                      </button>
                      <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="action-buttons">
                      <button
                        className="action-btn view"
                        onClick={() => handleViewEmployee(employee.id)}
                        disabled={isFetchingDetails}
                      >
                        {isFetchingDetails ? 'Loading...' : 'View'}
                      </button>
                      <button
                        className="action-btn edit"
                        onClick={() => handleEditEmployee(employee.id)}
                        disabled={isFetchingDetails}
                      >
                        {isFetchingDetails ? 'Loading...' : 'Edit'}
                      </button>
                      <button
                        className="action-btn password"
                        onClick={() => {
                          setSelectedEmployeeId(employee.id);
                          setShowPasswordModal(true);
                        }}
                        disabled={isFetchingDetails}
                      >
                        Password
                      </button>
                      <button
                        className="action-btn delete"
                        onClick={() => {
                          setEmployeeToDelete(employee.id);
                          setDeleteType('soft');
                          setShowDeleteConfirm(true);
                        }}
                        disabled={isFetchingDetails}
                      >
                        Deactivate
                      </button>
                      <button
                        className="action-btn permanent-delete"
                        onClick={() => {
                          setEmployeeToDelete(employee.id);
                          setDeleteType('permanent');
                          setShowDeleteConfirm(true);
                        }}
                        disabled={isFetchingDetails}
                        title="Permanently Delete"
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {employees.length === 0 && !loading && (
          <div className="no-data">
            <p>No employees found matching your search.</p>
            {searchTerm && (
              <button className="clear-filters-link" onClick={handleRefresh}>
                Clear search to see all employees
              </button>
            )}
          </div>
        )}
      </div>

      {/* Pagination */}
      <div className="pagination-container">
        <div className="pagination-info">
          Showing {employees.length} of {totalEmployees} employees (Page {currentPage} of {totalPages})
          {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
        </div>
        <div className="pagination-controls">
          <button
            className="pagination-btn"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <div className="page-numbers">
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNumber;
              if (totalPages <= 5) {
                pageNumber = i + 1;
              } else if (currentPage <= 3) {
                pageNumber = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNumber = totalPages - 4 + i;
              } else {
                pageNumber = currentPage - 2 + i;
              }

              return (
                <button
                  key={pageNumber}
                  className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                  onClick={() => handlePageClick(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>

          <button
            className="pagination-btn"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>

      {/* View Employee Modal */}
      {viewingEmployee && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Employee Details</h3>
              <button className="modal-close-btn" onClick={closeViewModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                {viewingEmployee.profileImage && (
                  <div className="customer-profile-image">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}/uploads/${viewingEmployee.profileImage}`}
                      alt={viewingEmployee.name}
                      className="profile-image-large"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                )}
                <div className="detail-row">
                  <label>Name:</label>
                  <span>{viewingEmployee.name || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Email:</label>
                  <span>{viewingEmployee.email || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Mobile Number:</label>
                  <span>{viewingEmployee.mobileNumber || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Role:</label>
                  <span>{viewingEmployee.role || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Department:</label>
                  <span>{viewingEmployee.department || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Position:</label>
                  <span>{viewingEmployee.position || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Created Date:</label>
                  <span>{viewingEmployee.createdAt}</span>
                </div>
                <div className="detail-row">
                  <label>Last Updated:</label>
                  <span>{viewingEmployee.updatedAt}</span>
                </div>
                <div className="detail-row">
                  <label>Status:</label>
                  <span className={`status-badge ${viewingEmployee.isActive ? 'active' : 'inactive'}`}>
                    {viewingEmployee.isActive ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for view modal */}
      {viewingEmployee && isFetchingDetails && <SkeletonModal />}

      {/* Add Employee Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={handleCloseAddModal}>
          <div className="modal-content1 add-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Add New Employee</h3>
              <button className="modal-close-btn" onClick={handleCloseAddModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="edit-form">
                <div className="form-group">
                  <label>Name:*</label>
                  <input
                    type="text"
                    name="name"
                    value={addForm.name}
                    onChange={handleAddFormChange}
                    className="form-control"
                    placeholder="Employee Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email:*</label>
                  <input
                    type="email"
                    name="email"
                    value={addForm.email}
                    onChange={handleAddFormChange}
                    className="form-control"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Password:*</label>
                  <input
                    type="password"
                    name="password"
                    value={addForm.password}
                    onChange={handleAddFormChange}
                    className="form-control"
                    placeholder="Password (min. 6 characters)"
                    required
                  />
                  <small className="form-text text-muted">Password must be at least 6 characters long</small>
                </div>
                <div className="form-group">
                  <label>Phone Number:</label>
                  <input
                    type="text"
                    name="phoneNumber"
                    value={addForm.phoneNumber}
                    onChange={handleAddFormChange}
                    className="form-control"
                    placeholder="Phone Number"
                  />
                </div>
                <div className="form-group">
                  <label>Role:*</label>
                  <select
                    name="role"
                    value={addForm.role}
                    onChange={handleAddFormChange}
                    className="form-control"
                    required
                  >
                    {roleOptions.map(role => (
                      <option key={role} value={role}>{role}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Department:</label>
                  <select
                    name="department"
                    value={addForm.department}
                    onChange={handleAddFormChange}
                    className="form-control"
                  >
                    <option value="">Select Department</option>
                    {departmentOptions.map(dept => (
                      <option key={dept} value={dept}>{dept}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Position:</label>
                  <input
                    type="text"
                    name="position"
                    value={addForm.position}
                    onChange={handleAddFormChange}
                    className="form-control"
                    placeholder="Position"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={handleCloseAddModal} disabled={isAddingEmployee}>
                Cancel
              </button>
              <button 
                className="action-btn save" 
                onClick={handleAddEmployee}
                disabled={isAddingEmployee}
              >
                {isAddingEmployee ? 'Creating...' : 'Create Employee'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Update Password Modal - Updated without currentPassword */}
      {showPasswordModal && !isFetchingDetails && (
        <div className="modal-overlay" onClick={handleClosePasswordModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Update Password</h3>
              <button className="modal-close-btn" onClick={handleClosePasswordModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="edit-form">
                <div className="form-group">
                  <label>New Password:*</label>
                  <input
                    type="password"
                    name="newPassword"
                    value={passwordForm.newPassword}
                    onChange={handlePasswordFormChange}
                    className="form-control"
                    placeholder="New Password (min. 6 characters)"
                    required
                  />
                  <small className="form-text text-muted">Password must be at least 6 characters long</small>
                </div>
                <div className="form-group">
                  <label>Confirm New Password:*</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={passwordForm.confirmPassword || ''}
                    onChange={handlePasswordFormChange}
                    className="form-control"
                    placeholder="Confirm New Password"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={handleClosePasswordModal} disabled={isUpdatingPassword}>
                Cancel
              </button>
              <button 
                className="action-btn save" 
                onClick={handleUpdatePassword}
                disabled={isUpdatingPassword}
              >
                {isUpdatingPassword ? 'Updating...' : 'Update Password'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Form Modal */}
      {editingEmployee && !isFetchingDetails && (
        <div className="modal-overlay" onClick={handleCancelEdit}>
          <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Edit Employee</h3>
              <button className="modal-close-btn" onClick={handleCancelEdit}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="edit-form">
                <div className="form-group">
                  <label>Name:</label>
                  <input
                    type="text"
                    name="name"
                    value={editForm.name || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Employee Name"
                  />
                </div>
                <div className="form-group">
                  <label>Email:</label>
                  <input
                    type="email"
                    name="email"
                    value={editForm.email || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Email Address"
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number:</label>
                  <input
                    type="text"
                    name="phoneNumber"
                    value={editForm.phoneNumber || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Phone Number"
                  />
                </div>
                <div className="form-group">
                  <label>Role:</label>
                  <select
                    name="role"
                    value={editForm.role || 'employee'}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    {roleOptions.map(role => (
                      <option key={role} value={role}>{role}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Department:</label>
                  <select
                    name="department"
                    value={editForm.department || ''}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Department</option>
                    {departmentOptions.map(dept => (
                      <option key={dept} value={dept}>{dept}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Position:</label>
                  <input
                    type="text"
                    name="position"
                    value={editForm.position || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Position"
                  />
                </div>
                <div className="form-group checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="isActive"
                      checked={editForm.isActive || false}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-text">Active Employee</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={handleCancelEdit}>
                Cancel
              </button>
              <button className="action-btn save" onClick={handleSaveEdit}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for edit modal */}
      {editingEmployee && isFetchingDetails && <SkeletonEditModal />}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="modal-overlay" onClick={() => setShowDeleteConfirm(false)}>
          <div className="modal-content1 confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{deleteType === 'permanent' ? 'Permanently Delete Employee' : 'Deactivate Employee'}</h3>
              <button className="modal-close-btn" onClick={() => setShowDeleteConfirm(false)}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>
                {deleteType === 'permanent' 
                  ? 'Are you sure you want to permanently delete this employee? This action cannot be undone.'
                  : 'Are you sure you want to deactivate this employee? They will no longer be able to access the system.'}
              </p>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={() => setShowDeleteConfirm(false)}>
                Cancel
              </button>
              <button 
                className={`action-btn ${deleteType === 'permanent' ? 'permanent-delete' : 'delete'}`} 
                onClick={handleDeleteEmployee}
              >
                {deleteType === 'permanent' ? 'Permanently Delete' : 'Deactivate'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Create Modal */}
      {showBulkModal && (
        <div className="modal-overlay" onClick={() => setShowBulkModal(false)}>
          <div className="modal-content1 bulk-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Bulk Create Employees</h3>
              <button className="modal-close-btn" onClick={() => setShowBulkModal(false)}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>Enter JSON array of employees:</p>
              <textarea
                value={bulkEmployees}
                onChange={(e) => setBulkEmployees(e.target.value)}
                className="bulk-textarea"
                rows={10}
                placeholder='[
  {
    "name": "John Doe",
    "email": "john@example.com",
    "password": "password123",
    "role": "manager",
    "phoneNumber": "+1234567890",
    "department": "Operations",
    "position": "Operations Manager"
  }
]'
              />
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={() => setShowBulkModal(false)}>
                Cancel
              </button>
              <button className="action-btn save" onClick={handleBulkCreate}>
                Create Employees
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeManagement;